import { DataFilter } from './interface';
import { Not, NumberGreaterThan } from '@vendasta/automata';
import { DaysInputDisplayService } from './dynamic-options/days-input/days-input-display.service';
import { DaysInputComponent } from './dynamic-options/days-input/days-input.component';

const USER_LAST_ONLINE = '{.user_data.last_online.days_ago}';
export class UserLastOnlineDataFilter implements DataFilter {
  rules = [new Not(new NumberGreaterThan(USER_LAST_ONLINE)), new NumberGreaterThan(USER_LAST_ONLINE)];
  dataEntryComponent = DaysInputComponent;
  displayService = DaysInputDisplayService;
  label = 'AUTOMATIONS.EDITOR.FILTERS.USER_DATA.DATA_LABELS.LAST_SEEN';
  comparisonLabels = [
    'AUTOMATIONS.EDITOR.FILTERS.USER_DATA.COMPARISON.WITHIN_DAYS',
    'AUTOMATIONS.EDITOR.FILTERS.USER_DATA.COMPARISON.NOT_WITHIN_DAYS',
  ];
}

export const USER_DATA_COMPONENTS: Map<string, DataFilter> = new Map<string, DataFilter>([
  [USER_LAST_ONLINE, new UserLastOnlineDataFilter()],
]);
